export default "__VITE_ASSET__CZtOJ_qK__"